import React, { createContext } from "react";
export var DarkModeContext = /*#__PURE__*/createContext(false);
export var checkIsDarkMode = function checkIsDarkMode() {
  var _window$matchMedia;

  return ((_window$matchMedia = window.matchMedia("(prefers-color-scheme: dark)")) === null || _window$matchMedia === void 0 ? void 0 : _window$matchMedia.matches) || false;
};
export var DarkMode = function DarkMode(_ref) {
  var children = _ref.children;
  // don't cache this value
  // this way, if the user switches to dark mode, we should be able to update on
  // the very next render
  var isInDarkMode = checkIsDarkMode();
  return /*#__PURE__*/React.createElement(DarkModeContext.Provider, {
    value: isInDarkMode
  }, children);
};